angular.module('impactx.cancellation').service('CancellationService', CancellationService);

CancellationService.$inject = ['dataGen', '$mdDialog', '$redirect'];

function CancellationService(dataGen, $mdDialog, $redirect)
{
    var checkCancelConditions = function (event, selected, showCancelDialog) {
        dataGen.getData({}, {selected: [selected]}, '/purchaserequest/cancellation/checkconditions').then(function(response) {
            if(response && response.data) {
                var result = response.data.result;
                if(result === 0) {
                    showCancelDialog(event);
                }
                else if(result === 1) {
                    $mdDialog.show({
                        controller: "CancelConditionCheckResultCtrl",
                        controllerAs: "cancelCtrl",
                        templateUrl: "modules/cancellation/templates/cancelconditioncheckresult.tmpl.html",
                        parent: angular.element(document.body),
                        targetEvent: event,
                        clickOutsideToClose: false,
                        locals: {
                            message: response.data.message,
                            question: response.data.question,
                            requestCancel: response.data.requestCancel,
                            requestItems: response.data.requestItemMap
                        }
                    }).then(function() {
                        showCancelDialog(event);
                    });
                }
            }
        });
    };
    
    this.cancelAll = function (event, selected) {
        checkCancelConditions(event, selected, function (event) {
            $mdDialog.show({
                controller: "CancelAllCtrl",
                controllerAs: "cancelAllCtrl",
                templateUrl: "modules/cancellation/templates/cancellation-all.tmpl.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    selectedEntries: selected
                }
            })
        });
    };

    this.cancelItems = function(event, selected) {
        checkCancelConditions(event, selected, function () {
            $redirect.redirectTo(null, "/cancelrequest", selected);
        });
    };
}